import { render, staticRenderFns } from "./ConcursosId.vue?vue&type=template&id=31c0fbdc&"
import script from "./concursosId.ts?vue&type=script&lang=ts&"
export * from "./concursosId.ts?vue&type=script&lang=ts&"
import style0 from "./ConcursosId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports